/* Round 2 items 22 + 23: one shared ship-by date for the PDP and its branded cart.
   Ship-by = next business day in America/New_York (weekends skipped: Fri, Sat, Sun -> Mon).
   Without JS the markup keeps the static fallback: "Ships within 1 business day via USPS. Arrives in 2 to 4 business days." (acfq-r7-A 3 hdr) */
(function(root){
'use strict';
const ARRIVAL='Arrives in 2 to 4 business days.';
const MONTHS=['January','February','March','April','May','June','July','August','September','October','November','December'];
const DAYS=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
function ord(n){const t=n%100;if(t>=11&&t<=13)return n+'th';return n+({1:'st',2:'nd',3:'rd'}[n%10]||'th');}
// Today's calendar date in New York, as a UTC midnight Date so day math ignores DST.
function todayET(now){
 const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(now||new Date());
 const get=t=>Number(parts.find(p=>p.type===t).value);
 return new Date(Date.UTC(get('year'),get('month')-1,get('day')));
}
function shipBy(now){
 const d=todayET(now);
 do{d.setUTCDate(d.getUTCDate()+1);}while(d.getUTCDay()===0||d.getUTCDay()===6);
 return d;
}
function label(d,withYear){return DAYS[d.getUTCDay()]+', '+MONTHS[d.getUTCMonth()]+' '+ord(d.getUTCDate())+(withYear?', '+d.getUTCFullYear():'');}
function paint(){
 if(!root.document)return;
 const d=shipBy();
 root.document.querySelectorAll('[data-acfq-ship]').forEach(el=>{
  const b=root.document.createElement('b');
  if(el.dataset.acfqShip==='cart'){b.textContent=label(d,true);el.replaceChildren('Your order is estimated to ship by ',b,' via USPS. '+ARRIVAL);}
  else{b.textContent=label(d,false);el.replaceChildren('Order today, estimated to ship by ',b,' via USPS. '+ARRIVAL);}
 });
}
// Round 3: delivery line under each Add to Cart. Conner ruled arrival = order date + 2 to + 4 business days (New York date, weekends skipped).
function addBusinessDays(d,n){const x=new Date(d.getTime());while(n>0){x.setUTCDate(x.getUTCDate()+1);if(x.getUTCDay()!==0&&x.getUTCDay()!==6)n--;}return x;}
/*acfq-r7-A 23: one rule. Order today, ships next business day (ET, Fri/Sat/Sun -> Mon), arrives ship date + 2 to + 4 business days, USPS.*/
function arrivalRange(now){const s=shipBy(now);return [addBusinessDays(s,2),addBusinessDays(s,4)];}
function shortLabel(d){return DAYS[d.getUTCDay()].slice(0,3)+', '+MONTHS[d.getUTCMonth()].slice(0,3)+' '+d.getUTCDate();}
// Delivery line under both Add to Carts. 1 jar pays shipping: show only "$4.95 shipping", no date (row 1). Everything else shows the same ship date the cart banner shows.
function deliverText(now,paidShip){return paidShip?'$4.95 shipping':'Fast & Free Delivery (ships by '+shortLabel(shipBy(now))+')';}
/*acfq-r7-A 23 end*/
function monthDay(d){return MONTHS[d.getUTCMonth()]+' '+d.getUTCDate();}
// "Free" only when the live shipping line shows no charge (1 jar one-time pays shipping).
function paintDeliver(){
 if(!root.document)return;
 const ship=root.document.getElementById('acfbp-initial-shipping');
 /*acfq-r7-A 23 paint*/const text=deliverText(null,!!(ship&&/\$/.test(ship.textContent)));
 root.document.querySelectorAll('[data-acfq-deliver] .acfq-deliver-text').forEach(el=>{if(el.textContent!==text)el.textContent=text;});
}
function watchDeliver(){
 paintDeliver();
 const ship=root.document.getElementById('acfbp-initial-shipping');
 if(ship&&root.MutationObserver)new MutationObserver(paintDeliver).observe(ship,{childList:true,characterData:true,subtree:true});
}
const api=Object.freeze({todayET,shipBy,label,shortLabel,deliverText,ARRIVAL,addBusinessDays,arrivalRange,paintDeliver});/*acfq-r7-A 23 api*/
if(typeof module!=='undefined')module.exports=api;
root.ACFQShip=api;
if(root.document){const run=()=>{paint();watchDeliver();};if(root.document.readyState==='loading')root.document.addEventListener('DOMContentLoaded',run);else run();}
})(typeof window==='undefined'?globalThis:window);
